const FORMULA = /^[\t\r\n]|^[ \v\f\t\r\n ﻿​-‏⁠]*[=+\-@]/;
const TEXT_LITERAL = /^="(?:[^"]|"")*"$/;

export function csvSafe(value) {
  if (
    typeof value !== 'string'
    || value.trim() === ''
    || !Number.isNaN(Number(value))
    || TEXT_LITERAL.test(value)
    || !FORMULA.test(value)
  ) {
    return value;
  }

  return `'${value}`;
}

const defaultHeader = ({ column, columnApi }) => (columnApi.columnController || columnApi)
  .getDisplayNameForColumn(column, 'csv', true);

export function guardCsvExport(api) {
  const exportDataAsCsv = api.exportDataAsCsv.bind(api);
  const cellOf = params => params.processCellCallback || (cell => cell.value);
  const headerOf = params => params.processHeaderCallback || defaultHeader;

  // eslint-disable-next-line no-param-reassign
  api.exportDataAsCsv = (params = {}) => exportDataAsCsv({
    ...params,
    processCellCallback: cell => csvSafe(cellOf(params)(cell)),
    processHeaderCallback: header => csvSafe(headerOf(params)(header)),
  });
}
